var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.show && _vm.isStaging
        ? _c(
            "v-system-bar",
            {
              staticClass: "staging-banner",
              attrs: { app: "", color: "#e65100" },
            },
            [
              _c("v-spacer"),
              _c(
                "v-icon",
                {
                  staticClass: "mr-1",
                  attrs: { "x-small": "", color: "white" },
                },
                [_vm._v("mdi-flask-outline")]
              ),
              _c("span", [_vm._v("Ambiente de Homologação")]),
              _c("span", { staticClass: "staging-banner__separator" }, [
                _vm._v("|"),
              ]),
              _c("span", [
                _vm._v("Os dados aqui não afetam o sistema em produção"),
              ]),
              _c("v-spacer"),
            ],
            1
          )
        : _vm._e(),
      _vm.show
        ? _c(
            "v-app-bar",
            {
              attrs: {
                app: "",
                "clipped-left": "",
                flat: "",
                color: "grey lighten-4",
              },
            },
            [
              _vm.menu.length > 0
                ? _c("v-app-bar-nav-icon", {
                    on: {
                      click: function ($event) {
                        _vm.drawer = !_vm.drawer
                      },
                    },
                  })
                : _vm._e(),
              _c("v-toolbar-title", [
                _c(
                  "a",
                  {
                    staticStyle: { cursor: "pointer" },
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.goToHome.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("v-img", {
                      attrs: {
                        src: "/img/sysclass_logo.png",
                        "max-width": "150",
                        alt: "Logo SysClass",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("v-spacer"),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showChangeWorkTime && _vm.menu.length > 0,
                      expression: "showChangeWorkTime && menu.length > 0",
                    },
                  ],
                  staticClass: "d-flex align-center mr-2",
                },
                [
                  _c(
                    "v-chip",
                    {
                      staticClass: "mr-2 font-weight-medium",
                      attrs: { outlined: "", color: "primary", small: "" },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-calendar"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.acesso.periodo
                              ? _vm.acesso.periodo.name
                              : "Selecionar"
                          ) +
                          " "
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        "offset-y": "",
                        left: "",
                        "max-width": "300",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "text-none",
                                        attrs: {
                                          small: "",
                                          outlined: "",
                                          color: "primary",
                                          loading: _vm.loadingWorkTime,
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { left: "", small: "" } },
                                      [_vm._v("mdi-swap-horizontal")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "hidden-sm-and-down" },
                                      [_vm._v("Trocar Período")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3305232266
                      ),
                      model: {
                        value: _vm.menuWorkTime,
                        callback: function ($$v) {
                          _vm.menuWorkTime = $$v
                        },
                        expression: "menuWorkTime",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "text-subtitle-2 pb-2" },
                            [_vm._v(" Selecionar Período ")]
                          ),
                          _c(
                            "v-card-text",
                            { staticClass: "pt-0" },
                            [
                              _c("SysSelectWorkTime", {
                                ref: "selectWorkTime",
                                attrs: {
                                  loading: _vm.loadingWorkTime,
                                  label: "Período",
                                  "filter-active": "",
                                  model: _vm.selectedWorkTime,
                                  dense: "",
                                  outlined: "",
                                  "return-object": "",
                                },
                                on: {
                                  "update:model": function ($event) {
                                    _vm.selectedWorkTime = $event
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { text: "", small: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.menuWorkTime = false
                                    },
                                  },
                                },
                                [_vm._v("Cancelar")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    small: "",
                                    disabled:
                                      !_vm.selectedWorkTime ||
                                      (_vm.acesso.periodo &&
                                        _vm.selectedWorkTime.id ===
                                          _vm.acesso.periodo.id),
                                    loading: _vm.loadingWorkTime,
                                  },
                                  on: { click: _vm.confirmChangeWorkTime },
                                },
                                [_vm._v(" Confirmar ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.user.id ? _c("EmcAccessibilityThemeToggle") : _vm._e(),
              _vm.user.id ? _c("SysNotificationNotificationBell") : _vm._e(),
              _vm.isTeacherPanelRoute
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "mr-1",
                                        attrs: { icon: "", loading: _vm.exit },
                                        on: {
                                          click: function ($event) {
                                            return _vm.sair()
                                          },
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [_c("v-icon", [_vm._v("mdi-logout")])],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4094253110
                      ),
                    },
                    [_c("span", [_vm._v("Sair")])]
                  )
                : _vm._e(),
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _vm.user.id && _vm.user.mode == "user"
                              ? _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticStyle: { cursor: "help" },
                                        attrs: {
                                          small: "",
                                          to: "/faq-questions",
                                          icon: "",
                                          "aria-label":
                                            "Ajuda e Perguntas Frequentes",
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          small: "",
                                          color: "indigo",
                                          "aria-hidden": "true",
                                        },
                                      },
                                      [_vm._v("mdi-help-circle-outline")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1916072554
                  ),
                },
                [_c("span", [_vm._v(" Ajuda ")])]
              ),
              _vm.user &&
              _vm.user.id &&
              _vm.$route.name != "availability-teacher"
                ? _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        "nudge-width": 100,
                        "offset-y": "",
                        "open-on-hover": !_vm.isTeacherPanelRoute,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "mr-1",
                                        attrs: { icon: "" },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _vm.user.id
                                      ? _c("EmcBaseAvatar", {
                                          staticClass: "avatar-clickthrough",
                                          attrs: {
                                            size: 36,
                                            src: _vm.user.url_avatar,
                                            text: _vm.user.initials,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2636927177
                      ),
                    },
                    [
                      _c(
                        "v-card",
                        { attrs: { "max-width": 400 } },
                        [
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-avatar",
                                    [
                                      _vm.user.id
                                        ? _c("EmcBaseAvatar", {
                                            attrs: {
                                              size: 36,
                                              src: _vm.user.url_avatar,
                                              text: _vm.user.initials,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(_vm._s(_vm.user.name)),
                                      ]),
                                      _c("v-list-item-subtitle", [
                                        _vm._v(_vm._s(_vm.user.email)),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c(
                            "v-list",
                            [
                              _vm.acesso.instituicao &&
                              _vm.acesso.instituicao.id &&
                              !_vm.isTeacherPanelRoute
                                ? _c(
                                    "v-list-item",
                                    {
                                      attrs: { to: "/profile" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showMenu = !_vm.showMenu
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [_c("v-icon", [_vm._v("mdi-account")])],
                                        1
                                      ),
                                      _c("v-list-item-title", [
                                        _vm._v("Meus Dados"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.isTeacherPanelRoute
                                ? _c(
                                    "v-list-item",
                                    { on: { click: _vm.openTeacherProfile } },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [_c("v-icon", [_vm._v("mdi-account")])],
                                        1
                                      ),
                                      _c("v-list-item-title", [
                                        _vm._v("Meus Dados"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.acesso.instituicao &&
                              _vm.acesso.instituicao.id &&
                              (_vm.user.is_master ||
                                _vm.user.allow_open_tickets) &&
                              !_vm.isTeacherPanelRoute
                                ? _c(
                                    "v-list-item",
                                    {
                                      attrs: { to: "/my-tickets" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showMenu = !_vm.showMenu
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-text-box"),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c("v-list-item-title", [
                                        _vm._v("Meus chamados"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.sair()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c("v-icon", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.exit
                                              ? "mdi-spin mdi-loading"
                                              : "exit_to_app"
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c("v-list-item-title", [_vm._v("Sair")]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-navigation-drawer",
        {
          attrs: { app: "", clipped: "", left: "", temporary: "" },
          model: {
            value: _vm.drawer,
            callback: function ($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer",
          },
        },
        [
          _c(
            "div",
            { staticClass: "pa-3" },
            [
              _c("FormsTextField", {
                staticClass: "full-width-search",
                attrs: {
                  placeholder: "Pesquisar menu...",
                  "append-icon": "mdi-magnify",
                  outlined: "",
                  dense: "",
                  "hide-details": "",
                },
                model: {
                  value: _vm.searchQuery,
                  callback: function ($$v) {
                    _vm.searchQuery = $$v
                  },
                  expression: "searchQuery",
                },
              }),
            ],
            1
          ),
          _c(
            "v-list",
            { attrs: { nav: "", dense: "" } },
            [
              _vm._l(_vm.filteredMenusSysclass, function (item) {
                return [
                  Object.keys(item.children).length > 0
                    ? _c(
                        "v-list-group",
                        {
                          key: item.id,
                          attrs: { "prepend-icon": item.icon },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(_vm._s(item.text)),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.model,
                            callback: function ($$v) {
                              _vm.$set(item, "model", $$v)
                            },
                            expression: "item.model",
                          },
                        },
                        _vm._l(item.children, function (child, i) {
                          return _c(
                            "v-list-item",
                            { key: i, attrs: { link: "", to: child.to } },
                            [
                              child.icon
                                ? _c(
                                    "v-list-item-action",
                                    [
                                      _c("v-icon", [
                                        _vm._v(_vm._s(child.icon)),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(child.text)),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _c(
                        "v-list-item",
                        { key: item.id, attrs: { link: "", to: item.to } },
                        [
                          _c(
                            "v-list-item-action",
                            [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(item.text)),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                ]
              }),
              _vm.filteredMenusInternal.length > 0
                ? _c("v-divider", { staticClass: "my-2" })
                : _vm._e(),
              _vm._l(_vm.filteredMenusInternal, function (item) {
                return [
                  Object.keys(item.children).length > 0
                    ? _c(
                        "v-list-group",
                        {
                          key: item.id,
                          attrs: { "prepend-icon": item.icon },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", [
                                          _vm._v(_vm._s(item.text)),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.model,
                            callback: function ($$v) {
                              _vm.$set(item, "model", $$v)
                            },
                            expression: "item.model",
                          },
                        },
                        _vm._l(item.children, function (child, i) {
                          return _c(
                            "v-list-item",
                            { key: i, attrs: { link: "", to: child.to } },
                            [
                              child.icon
                                ? _c(
                                    "v-list-item-action",
                                    [
                                      _c("v-icon", [
                                        _vm._v(_vm._s(child.icon)),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(child.text)),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _c(
                        "v-list-item",
                        { key: item.id, attrs: { link: "", to: item.to } },
                        [
                          _c(
                            "v-list-item-action",
                            [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(item.text)),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }